<div class="modal-overlay" [class.is-visible]="isOpen">
  <div class="position-absolute w-100 h-100" (click)="close()"></div>

  <div class="modal-box position-relative z-index-2">
    <div class="modal-floating-header-img">
      <img src="assets/images/vplogo.png" alt="Header Icon">
    </div>

    <button class="close-modal-btn" (click)="close()">&times;</button>

    <div class="modal-body-flex">

      <div class="modal-side-image">
        <img src="assets/images/vpsupport.png" alt="Freelancer">
        <div class="position-absolute w-100 h-100 top-0 start-0 bg-dark-gray opacity-2"></div>
      </div>

      <div class="modal-form-content">
        <div class="mb-4"></div>

        <div class="text-center mb-4">
          <p class="text-white opacity-8 fs-14">Please fill in your details to proceed.</p>
        </div>

        <form action="" class="download-form" (ngSubmit)="onSubmit($event)">
          <div class="modal-form-group">
            <label class="modal-label">Full Name <span class="text-white opacity-5">*</span></label>
            <input name="name" type="text" class="modal-input" required>
          </div>

          <div class="modal-form-group">
            <label class="modal-label">Email Address <span class="text-white opacity-5">*</span></label>
            <input name="email" type="email" class="modal-input" required>
          </div>

          <div class="modal-form-group">
            <label class="modal-label">Phone Number <span class="opacity-5 font-weight-normal">(Optional)</span></label>
            <input name="phone" type="tel" class="modal-input">
          </div>
          <br><br>
          <button id="downloadBtn" type="submit" [disabled]="isLoading" class="btn-proceed">{{isLoading ? 'Please Wait...' : 'Proceed'}}</button>
        </form>

        <form #form ngNoForm
          id="nonseamless" 
          method="post" 
          name="redirect" 
          action="{{formAction}}">
            <input type="hidden" id="encRequest" name="encRequest" value="{{encryptedData}}">
            <input type="hidden" name="access_code" id="access_code" value="{{accessCode}}">
        </form>
        
      </div>
    </div>
  </div>
</div>